export const ApplicationConstants = {
  API: {
    GATEWAY: String(process.env.REACT_APP_GATEWAY_SERVICE),
    ACCESS_MANAGER: String(process.env.REACT_APP_ACCESS_MANAGER_SERVICE),
  },
  SAAS_NAME: String(process.env.REACT_APP_SAAS_NAME),
  SAAS_FAVICON: String(process.env.REACT_APP_SAAS_FAVICON),
  SAAS_LOGO: String(process.env.REACT_APP_SAAS_LOGO),
};

export enum SaasName {
  EINSTEIN = 'EINSTEIN',
  FLEURY = 'FLEURY',
  CAREPLUS = 'CAREPLUS',
}

export enum HttpMethod {
  GET = 'GET',
  PATCH = 'PATCH',
}

const url = window.location;
export const token = new URLSearchParams(url.search).get('token');
